module.exports = __webpack_public_path__ + "static/08-06a424cb445b5df06bdb972221de2825.jpg";